// extracted by mini-css-extract-plugin
module.exports =  {"textRight":"jut__TableColumn__textRight","textLeft":"jut__TableColumn__textLeft","textCenter":"jut__TableColumn__textCenter","tableCell":"jut__TableColumn__tableCell"};